// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { setProductData } from '../../actions'
import { loadingToggler } from 'redux/modules/loading'
import initSortData from './initSortData'
import quarterCell from './quarterCell'

import {
  assembleQuery,
  fetchWrapper,
} from 'helpers/api'

const getProductData = (uid) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const dataProducts = getState().dataProducts

      // if the data isn't expired yet, just return what we have in redux store.
      if (dataProducts?.[uid]?.dataExpiration > Date.now()) {
        return dataProducts[uid].data
      }

      try {
        const query = assembleQuery([{
          value: uid,
          field: 'dataCategory',
        }])

        let data = await fetchWrapper(`/dataReports${query}`)
        
        data = quarterCell(data)
        data = await initSortData(data)

        const action = {
          data,
          dataExpiration: Date.now() + (1000 * 60 * 60 * 24),
        }

        dispatch(setProductData(uid, action))
        return action.data
      } catch (err) {
        console.warn(err)
        throw err
      }
    })
  )
)

export default getProductData
